module.exports = __webpack_public_path__ + "logo-e12eec866adb4e70f3eba80cbfaf092a.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/logo.png
// module id = 297
// module chunks = 0